import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../../config');

class ModalPlaces extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSave = this.onSave.bind(this);

		this.state = {
			show: false,
			health_facilities:[],
			health_facilities_id:"",
			groups:[],
			order:"",
			center_name:"",
			group:"",
			code:"",
			name:"",
			active:true,
			operative:false,
			center_address:false,
			street:"",
			number:"",
			postal_code:"",
			colony:"",
			state:"",
			states:[],
			mpio:"",
			mpios:[],
			observations:"",
			citation:true
		}
	}

	componentDidMount(){
		this.props.onRef(this);
		
	}

	handleShow(){

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'health_facilities',{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities:response
				});
			}
		});

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'lookups?type=CONVOKE_PLACES_GROUP&option=actives&order=true',{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					groups:response
				});
			}
		});

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'convoke_places',{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					order:response
				});
			}
		});

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'lookups_level2?type=state_mx&option=parents',{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					states:response
				});
			}
		});

		this.setState({show:true});
				
	}

	handleClose(){
		this.setState({
			show: false,
			health_facilities:[],
			health_facilities_id:"",
			groups:[],
			order:"",
			center_name:"",
			group:"",
			code:"",
			name:"",
			active:false,
			operative:false,
			center_address:false,
			street:"",
			number:"",
			postal_code:"",
			colony:"",
			state:"",
			states:[],
			mpio:"",
			mpios:[],
			observations:"",
			citation:true
		});
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
		});

		if(e.target.name === 'state'){
			this.getMpios(e.target.value);
		}
	}

	onSave(){
		if(this.validForm()){
			var obj = {
				active: this.state.active ? 1 : 0,
				address:{
					colonia:this.state.colony,
					estado:this.state.state,
					ext_num:this.state.number,
					municipio:this.state.mpio,
					postal_code:this.state.postal_code,
					street:this.state.street
				},
				citas:this.state.citation ? 1 : 0,
				code:this.state.code,
				group_convoke:this.state.group,
				health_facilities_id:this.state.health_facilities_id,
				name:this.state.name,
				observations:this.state.observations,
				operatives:this.state.operative,
				order:this.state.order
			};

			this.props.waiting.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+'convoke_places',{
				method:'post',
				body:JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					swal('Correcto', 'El registro se guardo correctamente.', 'success');
					this.props.getConvokePlace();
					this.handleClose();
				}
			});
		}else{

		}
	}

	validForm(){
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
    			const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
	    			   
		  	}
	    });
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {
			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		
		return res;
	}

	getMpios(key){
		fetch(Config.default.apiGateway.URL+'lookups_level2?type='+key+'&option=parents',{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({mpios:response});
			}
		});
	}


	render(){
		const {t} = this.props;
		return (
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles de Entrada</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<fieldset className="col-xs-12 form-group">
		        			<legend>Datos</legend>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Unidad / Hospital</span>
		        				<select className="form-control" name="health_facilities_id" id="health_facilities_id" value={this.state.health_facilities_id}
		        					onChange={this.handleChange} required>
		        					<option value="">Seleccione...</option>
		        					{this.state.health_facilities.map((h, i)=>(
		        						<option key={i} value={h.id}>
		        							{h.national_centers.short_name}
		        						</option>
		        					))}
		        				</select>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Grupo</span>
		        				<select className="form-control" name="group" id="group" value={this.state.group}
		        					onChange={this.handleChange}>
		        					<option value="">Seleccione...</option>
		        					{this.state.groups.map((g, i)=>(
		        						<option key={i} value={g.key}>
		        							{g.name}
		        						</option>
		        					))}
		        				</select>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Código</span>
		        				<input className="form-control" name="code" id="code" value={this.state.code}
		        					onChange={this.handleChange} required />
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Nombre</span>
		        				<input className="form-control" name="name" id="name" value={this.state.name}
		        					onChange={this.handleChange} required />
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Orden</span>
		        				<input className="form-control" name="order" id="order" value={this.state.order}
		        					onChange={this.handleChange} disabled />
		        			</div>
		        			<div className="col-xs-12 col-sm-3" style={{marginTop:'20px'}}>
		        				<span className="span-min">Activo</span>
		        				<input type="checkbox" name="active" id="active" value={this.state.active}
		        					onChange={this.handleChange} style={{marginLeft:'5px'}} 
		        					checked={this.state.active}/>
		        			</div>
		        			{/*<div className="col-xs-12 col-sm-3" style={{marginTop:'20px'}}>
		        				<span className="span-min">Operativo</span>
		        				<input type="checkbox" name="operative" id="operative" value={this.state.operative}
		        					onChange={this.handleChange} style={{marginLeft:'5px'}} />
		        			</div>*/}

		        		</fieldset>
		        		<fieldset className="col-xs-12">
		        			<legend>Dirección</legend>
		        			<div className="col-xs-12">
		        				<input type="checkbox" name="center_address" id="center_address" value={this.state.center_address}
		        					onChange={this.handleChange} style={{marginRight:'5px'}} />
		        				<span className="span-min">Usar Dirección del Centro</span>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Calle</span>
		        				<input className="form-control" name="street" id="street" value={this.state.street}
		        					onChange={this.handleChange} />
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Colonia</span>
		        				<input className="form-control" name="colony" id="colony" value={this.state.colony}
		        					onChange={this.handleChange} />
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">No. Interior/Exterior</span>
		        				<input className="form-control" name="number" id="number" value={this.state.number}
		        					onChange={this.handleChange} />
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Código Postal</span>
		        				<input className="form-control" name="postal_code" id="postal_code" value={this.state.postal_code}
		        					onChange={this.handleChange} />
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Estado</span>
		        				<select className="form-control" name="state" id="state" value={this.state.state}
		        					onChange={this.handleChange} >
		        					<option value="">Seleccione...</option>
		        					{this.state.states.map((s, i)=>(
		        						<option key={i} value={s.key}>{s.value_name}</option>
		        					))}
		        				</select>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Municipio</span>
		        				<select className="form-control" name="mpio" id="mpio" value={this.state.mpio}
		        					onChange={this.handleChange}>
		        					<option value="">Seleccione...</option>
		        					{this.state.mpios.map((m, i)=>(
		        						<option key={i} value={m.key}>{m.value_name}</option>
		        					))}
		        				</select>
		        			</div>
		        			<div className="col-xs-12 form-group">
		        				<span className="span-min">Observaciones</span>
		        				<textarea className="form-control" name="observations" id="observations" value={this.state.observations}
		        					onChange={this.handleChange} />
		        			</div>
		        			<div className="col-xs-12">
		        				<input type="checkbox" name="citation" id="citation" value={this.state.citation}
		        					onChange={this.handleChange} style={{marginRight:'5px'}} checked={this.state.citation} />
		        				<span className="span-min">Lugar Citación</span>
		        				
		        			</div>
		        		</fieldset>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')}  onClick={this.onSave}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>

		)
	}

} 

export default translate('translations') (ModalPlaces);